import React from 'react';
import { BrowserRouter, Outlet, Route, Routes } from 'react-router-dom';
import { useInitializeKnowledgeTestState } from 'src/hooks/useInitializeKnowledgeTestState';
import InvestmentNoteDetails from 'src/modules/investmentNote/views/InvestmentNoteDetails';
import Layout from '../components/Layout';
import PageNotFound from '../components/PageNotFound';
import ForgotPassword from '../modules/auth/views/ForgotPassword';
import Login from '../modules/auth/views/Login';
import Logout from '../modules/auth/views/Logout';
import ResetPassword from '../modules/auth/views/ResetPassword';
import TwoFactorAuth from '../modules/auth/views/TwoFactorAuth';
import DefaultAndRecovery from '../modules/faq/views/DefaultAndRecovery';
import Eligibility from '../modules/faq/views/Eligibility';
import FeesAndCharges from '../modules/faq/views/FeesAndCharges';
import GeneralEnquiries from '../modules/faq/views/GeneralEnquiries';
import InvestNowFaq from '../modules/faq/views/InvestNow';
import InvestmentMemos from '../modules/faq/views/InvestmentMemos';
import RegistrationProcess from '../modules/faq/views/RegistrationProcess';
import Repayments from '../modules/faq/views/Repayments';
import RiskManagement from '../modules/faq/views/RiskManagement';
import TypesOfInvestmentNotes from '../modules/faq/views/TypesOfInvestmentNotes';
import FirstTimeDashboard from '../modules/firstTimeDashboard/views/WizardForm';
import InvestNow from '../modules/investNow/views/InvestNow';
import MyProfile from '../modules/myProfile/views/MyProfile';
import Performance from '../modules/performance/views/Performance';
import Portfolio from '../modules/portfolio/views/Portfolio';
import RegistrationCompleted from '../modules/registration/views/RegistrationCompleted';
import RegistrationStepsWizardForm from '../modules/registration/views/RegistrationStepsWizardForm';
import SignUp from '../modules/registration/views/SignUp';
import Transaction from '../modules/transaction/views/Transaction';
import { ProtectedRoute } from '../utils/ProtectedRoute';
import ROUTE_NAME from './RouteName';

const InitializedContent = () => {
    useInitializeKnowledgeTestState();

    return (
        <div className="container__wrap">
            <Outlet />
            <InvestmentNoteDetails />
        </div>
    );
};

const Router = () => {
    return (
        <BrowserRouter>
            <Layout />
            <Routes>
                <Route path={ROUTE_NAME.HOME} element={<Login />} />
                <Route path={ROUTE_NAME.TWO_FACTOR_AUTH} element={<TwoFactorAuth />} />
                <Route path={ROUTE_NAME.REGISTRATION} element={<SignUp />} />
                <Route path={ROUTE_NAME.REGISTRATION_DETAILS} element={<RegistrationStepsWizardForm />} />
                <Route path={ROUTE_NAME.REGISTRATION_COMPLETED} element={<RegistrationCompleted />} />
                <Route path={ROUTE_NAME.FORGOT_PASSWORD} element={<ForgotPassword />} />
                <Route path={ROUTE_NAME.RESET_PASSWORD} element={<ResetPassword />} />
                <Route path={ROUTE_NAME.LOGOUT} element={<ProtectedRoute><Logout /></ProtectedRoute>} />

                <Route path="" element={<InitializedContent />}>
                    <Route path={ROUTE_NAME.FIRST_TIME_DASHBOARD} element={<ProtectedRoute><FirstTimeDashboard /></ProtectedRoute>} />
                    <Route path={ROUTE_NAME.INVEST_NOW} element={<ProtectedRoute><InvestNow /></ProtectedRoute>} />
                    <Route path={ROUTE_NAME.PERFORMANCE} element={<ProtectedRoute><Performance /></ProtectedRoute>} />
                    <Route path={ROUTE_NAME.PORTFOLIO} element={<ProtectedRoute><Portfolio /></ProtectedRoute>} />
                    <Route path={ROUTE_NAME.PROFILE} element={<ProtectedRoute><MyProfile /></ProtectedRoute>} />
                    <Route path={ROUTE_NAME.TRANSACTION} element={<ProtectedRoute><Transaction /></ProtectedRoute>} />
                    <Route path={ROUTE_NAME.FAQ_GENERAL_ENQUIRIES} element={<ProtectedRoute><GeneralEnquiries /></ProtectedRoute>} />
                    <Route path={ROUTE_NAME.FAQ_ELIGIBILITY} element={<ProtectedRoute><Eligibility /></ProtectedRoute>} />
                    <Route path={ROUTE_NAME.FAQ_REGISTRATION_PROCESS} element={<ProtectedRoute><RegistrationProcess /></ProtectedRoute>} />
                    <Route path={ROUTE_NAME.FAQ_INVEST_NOW} element={<ProtectedRoute><InvestNowFaq /></ProtectedRoute>} />
                    <Route path={ROUTE_NAME.FAQ_TYPES_OF_INVESTMENT_NOTES} element={<ProtectedRoute><TypesOfInvestmentNotes /></ProtectedRoute>} />
                    <Route path={ROUTE_NAME.FAQ_REPAYMENTS} element={<ProtectedRoute><Repayments /></ProtectedRoute>} />
                    <Route path={ROUTE_NAME.FAQ_INVESTMENT_MEMOS} element={<ProtectedRoute><InvestmentMemos /></ProtectedRoute>} />
                    <Route path={ROUTE_NAME.FAQ_RISK_MANAGEMENT} element={<ProtectedRoute><RiskManagement /></ProtectedRoute>} />
                    <Route path={ROUTE_NAME.FAQ_FEES_AND_CHARGES} element={<ProtectedRoute><FeesAndCharges /></ProtectedRoute>} />
                    <Route path={ROUTE_NAME.FAQ_DEFAULT_AND_RECOVERY} element={<ProtectedRoute><DefaultAndRecovery /></ProtectedRoute>} />
                </Route>

                <Route path="*" element={<PageNotFound />} />
            </Routes>
        </BrowserRouter>
    );
};

export default Router;
